import { InputGroup, RoundButton, TextSizes } from "@smartsuite/react-ui/lib";
import { useState } from "react";
import { t } from "i18next";
import TextareaAutosize from "react-textarea-autosize";
import { useRootStore } from "../../../../stores/hooks";
import {
  StyledButtonsPanel,
  StyledDropPanelContent,
  StyledEmptyButton,
} from "./style";
import { observer } from "mobx-react-lite";
import { SolutionColorVariables } from "@smartsuite/types";

export const AutomationDescriptionPopup = observer<{
  isEditActive: boolean;
  onCancel: () => void;
  onSave: (description: string) => void;
}>(({ isEditActive, onCancel, onSave }) => {
  const candidate = useRootStore().automations.candidate;
  const [description, setDescription] = useState(candidate.self.description);
  const [focus, setFocus] = useState<boolean>(true);

  return (
    <>
      {isEditActive && (
        <>
          <StyledDropPanelContent onClick={(e) => e.stopPropagation()}>
            <InputGroup state={focus ? "active" : "default"}>
              <TextareaAutosize
                maxLength={250}
                /* eslint-disable-next-line jsx-a11y/no-autofocus */
                autoFocus={true}
                value={description}
                placeholder={focus ? t("3dot-menu.describe-automation") : ""}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                style={{ fontFamily: "inherit", fontSize: 13 }}
              />
            </InputGroup>

            <StyledButtonsPanel>
              <StyledEmptyButton
                onClick={(e) => {
                  e.stopPropagation();
                  onCancel();
                }}
              >
                {t("general.cancel")}
              </StyledEmptyButton>
              <RoundButton
                styles={{
                  ...{
                    backgroundColor: SolutionColorVariables.sc1,
                    textSize: TextSizes.S,
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onSave(description);
                }}
              >
                {t("3dot-menu.save-description")}
              </RoundButton>
            </StyledButtonsPanel>
          </StyledDropPanelContent>
        </>
      )}
    </>
  );
});
